"use client";
import { jsx } from "react/jsx-runtime";
import { useAnalyticObserverRef } from "../../../utils/observable/utils.js";
import { useCallback } from "react";
import { useTracking } from "react-tracking";
import { Analytics } from "../../Analytics/index.js";
import { TRACK_TYPE_VIEW } from "../../Analytics/constants.js";
import { useCheckScreen } from "../../../hooks/useCheckScreen/index.js";
import { FeatureHighlightCardV2Skeleton } from "./FeatureHighlightCardV2Skeleton.js";
import { COMPONENT_NAME, VIEW_NAME_MAP } from "./constants.js";
import { getAnalyticsData } from "./lib.js";
import { FeatureCard } from "./view.feature.js";
import { GeneralCard } from "./view.general.js";
import { ImageWithLegend } from "./view.imageWithLegend.js";
import { StyledTileContainer } from "./styles.js";
function FeatureHighlightCardV2UI({
  data,
  isLoading = false,
  analyticsTitlePrefix,
  enableOnViewTracking
}) {
  var _a;
  const { isBiggerDesktop, isDesktop, isTablet, isMobile } = useCheckScreen();
  const { trackEvent } = useTracking();
  let analyticsTitle = data == null ? void 0 : data.title;
  if (analyticsTitlePrefix) {
    analyticsTitle = `${analyticsTitlePrefix} | ${analyticsTitle}`;
  }
  const analyticsData = {
    adItem: {
      style: "feature highlight card",
      title: analyticsTitle,
      type: "category",
      url: data == null ? void 0 : data.url
    },
    doNotTrack: (_a = data == null ? void 0 : data.privacy_toggle) == null ? void 0 : _a.disable_third_party_tracking,
    itemCuration: "costco"
  };
  const onViewAnalyticHandler = useCallback(() => {
    trackEvent({ contentImp: analyticsTitle, trackType: TRACK_TYPE_VIEW });
  }, [trackEvent, analyticsTitle]);
  const observableRef = useAnalyticObserverRef({
    onView: onViewAnalyticHandler,
    enabled: !!enableOnViewTracking
  });
  if (isLoading) {
    return /* @__PURE__ */ jsx(FeatureHighlightCardV2Skeleton, {});
  }
  if (!data) {
    console.error(`${COMPONENT_NAME} error: no valid data`);
    return null;
  }
  let view;
  const card_row_config = data.card_row_config;
  let viewportConfig = card_row_config == null ? void 0 : card_row_config.small_viewport;
  if (isBiggerDesktop) {
    viewportConfig = card_row_config == null ? void 0 : card_row_config.extra_large_viewport;
  } else if (isDesktop) {
    viewportConfig = card_row_config == null ? void 0 : card_row_config.large_viewport;
  } else if (isTablet) {
    viewportConfig = card_row_config == null ? void 0 : card_row_config.medium_viewport;
  } else if (isMobile) {
    viewportConfig = card_row_config == null ? void 0 : card_row_config.small_viewport;
  }
  switch (data == null ? void 0 : data.select_card_style_variant) {
    case "feature_variant":
      view = /* @__PURE__ */ jsx(FeatureCard, { data });
      break;
    case "general_variant":
      view = /* @__PURE__ */ jsx(GeneralCard, { data });
      break;
    case "image_with_legend":
      view = /* @__PURE__ */ jsx(ImageWithLegend, { data });
      break;
    default:
      console.error(
        "invalid card style variant: " + (data == null ? void 0 : data.select_card_style_variant)
      );
      return null;
  }
  const { title, url } = getAnalyticsData(data) || {};
  return /* @__PURE__ */ jsx(Analytics, { analyticData: analyticsData, children: /* @__PURE__ */ jsx(
    StyledTileContainer,
    {
      "data-testid": VIEW_NAME_MAP[data == null ? void 0 : data.select_card_style_variant],
      "data-layout": viewportConfig,
      ref: observableRef,
      children: view
    }
  ) });
}
FeatureHighlightCardV2UI.displayName = COMPONENT_NAME;
export {
  FeatureHighlightCardV2UI
};
